// Auth Reducer Types
interface AuthState {
	isLoggedIn: boolean;
	role?: number;
	user?: any; // You can replace `any` with a more specific type if available
}

interface AuthLoadSuccessAction {
	type: "AUTH_LOAD_SUCCESS";
	payload: any; // Replace `any` with the actual user data type if available
}

interface AuthLoadFailureAction {
	type: "AUTH_LOAD_FAILURE";
}

interface AuthLoginSuccessAction {
	type: "AUTH_LOGIN_SUCCESS";
	payload: any;
}

interface AuthLogoutSuccessAction {
	type: "AUTH_LOGOUT_SUCCESS";
}

interface LoginSuccessAction {
	type: "LOGIN_SUCCESS";
	payload: any; // Replace `any` with the actual user data type if available
}

interface LogoutSuccessAction {
	type: "LOGOUT_SUCCESS";
}

type AuthAction = AuthLoadSuccessAction | AuthLoadFailureAction | AuthLoginSuccessAction | AuthLogoutSuccessAction | LoginSuccessAction | LogoutSuccessAction;

export const authReducer = (
	state: AuthState = {
		isLoggedIn: false,
		role: undefined,
		user: undefined,
	},
	action: AuthAction
): AuthState => {
	switch (action.type) {
		case "AUTH_LOAD_SUCCESS":
			return {
				...state,
				// role: action.payload.role_id,
				isLoggedIn: true,
				user: action.payload,

			};
		case "AUTH_LOAD_FAILURE":
			return {
				...state,
				isLoggedIn: false,
				role: -1,
			};
		case "AUTH_LOGIN_SUCCESS":
			return {
				...state,
				// role: action.payload.role_id,
				isLoggedIn: true,
			};
		case "AUTH_LOGOUT_SUCCESS":
			return {
				isLoggedIn: false,
				user: undefined,
				role: -1,
			};
		case "LOGIN_SUCCESS":
			return {
				isLoggedIn: true,
				user: action.payload,
			};

		case "LOGOUT_SUCCESS":
			return {
				isLoggedIn: false,
				role: -1,
			};

		default:
			return state;
	}
};
